import React, { useEffect, useCallback, useState, useRef } from "react";
import { useObjectivesList } from "../../../hooks/useObjectivesList";
import AtSelectPeriod from "../../../components/AtSelectPeriod/AtSelectPeriod";
import moment from "moment-timezone";
import "moment/locale/es";
import {
    createSelectedPeriodState,
    defaultPeriodsGeneralStatus,
} from "../../../utils/fns/generate-period-state";
import {
    Box,
    Dialog,
    Grid,
    IconButton,
    LinearProgress,
    Typography,
    Switch
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { FilterTags } from "../../../components/TagsAtentus/FilterTags";
import { Alert } from "@material-ui/lab";
import ListObjectiveModal from "../../Dashboard/components/ListObjectiveModal";
import UpdateIcon from "@material-ui/icons/Update";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import { useInterval } from "../../../hooks/useInterval";
import { ConfigPopover } from "./ConfigPopover";
import { ObjectiveZoomGraph } from "./ObjectiveZoomGraph";
import { getDetalleDisponibilidadParcialObjetivoDowntime } from "../../../services/getObjectives/get-objectives-status";
import { filterObjectivesByTags } from "../../../utils/tags";
import queryString from "query-string";
import { COLORS } from "../../../utils/colors";
import { useTranslation } from "react-i18next";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
function getSeries(externalDataConsolidated, index, isSpecial, t) {
    const { estado } = externalDataConsolidated.Objetivo.Nodo[0];

    let dictDataStackedBarUptime = {};
    dictDataStackedBarUptime["name"] = "Uptime";
    dictDataStackedBarUptime["pointWidth"] = 10;
    let arrayDataUptime = [];

    let dictDataStackedBarDowntime = {};
    dictDataStackedBarDowntime["name"] = "Downtime";
    dictDataStackedBarDowntime["pointWidth"] = 10;
    let arrayDataDowntime = [];

    let dictDataStackedBarNoMon = {};
    dictDataStackedBarNoMon["name"] = "No Monitoreo";
    dictDataStackedBarNoMon["pointWidth"] = 10;
    let arrayDataNoMon = [];

    let dictDataStackedBarPartial = {};
    dictDataStackedBarPartial["name"] = "Downtime Parcial";
    dictDataStackedBarPartial["pointWidth"] = 10;
    let arrayDataPartial = [];

    let dictDataStackedBarEventoCliente = {};
    dictDataStackedBarEventoCliente["name"] = "Evento Cliente";
    dictDataStackedBarEventoCliente["pointWidth"] = 10;
    let arrayDataEventoCliente = [];

    let dictDataStackedBarMarcadoAtentus = {};
    dictDataStackedBarMarcadoAtentus["name"] = "Marcado Atentus";
    dictDataStackedBarMarcadoAtentus["pointWidth"] = 10;
    let arrayDataMarcadoAtentus = [];

    Object.keys(estado).forEach((key) => {
        let dictDataStackedBar = {};

        let dateJson = new Date(estado[key]["fecha_desde"].substring(0, 19));
        let year = dateJson.getFullYear();
        let month = dateJson.getMonth();
        let day = dateJson.getDate();
        let hours = dateJson.getHours();
        let minutes = dateJson.getMinutes();
        let seconds = dateJson.getSeconds();

        let dateJsonEnd = new Date(estado[key]["fecha_hasta"].substring(0, 19));
        let yearEnd = dateJsonEnd.getFullYear();
        let monthEnd = dateJsonEnd.getMonth();
        let dayEnd = dateJsonEnd.getDate();
        let hoursEnd = dateJsonEnd.getHours();
        let minutesEnd = dateJsonEnd.getMinutes();
        let secondsEnd = dateJsonEnd.getSeconds();

        dictDataStackedBar["x"] = Date.UTC(
            year,
            month,
            day,
            hours,
            minutes,
            seconds
        );
        dictDataStackedBar["x2"] = Date.UTC(
            yearEnd,
            monthEnd,
            dayEnd,
            hoursEnd,
            minutesEnd,
            secondsEnd
        );
        dictDataStackedBar["y"] = index;
        if (isSpecial) {
            if (estado[key]['nombre'] == 'uptime') {
                if (arrayDataUptime.length) {
                    let lastUptime = arrayDataUptime[arrayDataUptime.length - 1]
                    if (lastUptime['x2'] === dictDataStackedBar['x']) {
                        lastUptime['x2'] = dictDataStackedBar['x2']
                        arrayDataUptime[arrayDataUptime.length - 1] = lastUptime
                    } else {
                        dictDataStackedBar['color'] = COLORS.UPTIME
                        arrayDataUptime.push(dictDataStackedBar)
                    }
                } else {
                    dictDataStackedBar['color'] = COLORS.UPTIME
                    arrayDataUptime.push(dictDataStackedBar)
                }
            } else if (estado[key]['nombre'] == 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME
                arrayDataDowntime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                arrayDataNoMon.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime parcial') {
                if (Number(key) > 0 && estado[Number(key) - 1].nombre == 'uptime') {
                    let lastUptime = arrayDataUptime.pop()
                    lastUptime['x2'] = dictDataStackedBar['x2']
                    arrayDataUptime.push(lastUptime)
                } else {
                    dictDataStackedBar['color'] = COLORS.UPTIME
                    arrayDataUptime.push(dictDataStackedBar)
                }
            } else if (estado[key]['nombre'] == 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                arrayDataEventoCliente.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                arrayDataMarcadoAtentus.push(dictDataStackedBar)
            }
        } else {
            if (estado[key]['nombre'] == 'uptime') {
                dictDataStackedBar['color'] = COLORS.UPTIME
                arrayDataUptime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME
                arrayDataDowntime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                arrayDataNoMon.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime parcial') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                arrayDataPartial.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                arrayDataEventoCliente.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                arrayDataMarcadoAtentus.push(dictDataStackedBar)
            }
        }
    });

    dictDataStackedBarUptime["data"] = arrayDataUptime;
    dictDataStackedBarDowntime["data"] = arrayDataDowntime;
    dictDataStackedBarNoMon["data"] = arrayDataNoMon;
    dictDataStackedBarPartial["data"] = arrayDataPartial;
    dictDataStackedBarEventoCliente["data"] = arrayDataEventoCliente;
    dictDataStackedBarMarcadoAtentus["data"] = arrayDataMarcadoAtentus;
    dictDataStackedBarUptime.name = t('general-status.graph.status.uptime');
    dictDataStackedBarDowntime.name = t('general-status.graph.status.downtime');
    dictDataStackedBarPartial.name = t('general-status.graph.status.partial-downtime');
    dictDataStackedBarNoMon.name = t('general-status.graph.status.no-monitoring');
    dictDataStackedBarEventoCliente.name = t('general-status.graph.status.client-event');
    dictDataStackedBarMarcadoAtentus.name = t('general-status.graph.status.downtime');

    const consolidatedData = {
        obj: externalDataConsolidated.Objetivo,
        uptime: dictDataStackedBarUptime,
        down: dictDataStackedBarDowntime,
        noMon: dictDataStackedBarNoMon,
        parcial: dictDataStackedBarPartial,
        eventoCliente: dictDataStackedBarEventoCliente,
        marcadoCliente: dictDataStackedBarMarcadoAtentus,
    };

    const detailIndividualData = [
        dictDataStackedBarUptime,
        dictDataStackedBarDowntime,
        dictDataStackedBarNoMon,
        dictDataStackedBarPartial,
        dictDataStackedBarEventoCliente,
        dictDataStackedBarMarcadoAtentus,
    ];

    return { detailIndividualData, consolidatedData };
}

const INTERVAL = 300000;

const autoRefreshSaved = localStorage.getItem("autoRefreshNewGeneralStatus");
const autoRefreshSavedValue = Number(autoRefreshSaved) || null;
const CLIENT_BBVA_AR = '5467' /*SOLO PARA ESTADO GENERAL BBVA*/
const email = sessionStorage.getItem('email')

function getListData() {
    let data = null;
    if (sessionStorage.getItem("listsLoads") === "true") {
        data = JSON.parse(sessionStorage.getItem("listaData"));
    }
    return data;
}

export function PanelAvailabilityCopy({
    filterType,
    etiquetas,
    selectedPeriodState,
    active,
}) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [apiData, setApiData] = useState(null);
    const [filterTagsType, setFilterTagsType] = useState(filterType);
    const [filterTagsId, setFilterTagsId] = useState(etiquetas);
    const [periodState, setPeriodState] = useState(selectedPeriodState);
    const [activePeriodState] = useState(active);
    const [dataModal, setDataModal] = useState({
        open: false,
        objId: null,
        objNameModal: null,
    });
    const [configEl, setConfigEl] = useState(null);
    const [autoRefresh, setAutoRefresh] = useState(
        autoRefreshSavedValue || INTERVAL
    );
    const [lastUpdate, setLastUpdate] = useState(new Date());
    const {
        data: objectives,
        isLoading: isLoadingObjectives,
    } = useObjectivesList({ fromStorage: true });
    const [objectivesListData] = useState(getListData());
    const [isGlobal, setIsGlobal] = useState(sessionStorage.getItem("client_id") === CLIENT_BBVA_AR)
    const [isSpecial, setIsSpecial] = useState(sessionStorage.getItem("client_id") === CLIENT_BBVA_AR ? true : false)
    useInterval(() => {
        processData();
    }, autoRefresh);
    const [dataModalFullscreen, setDataModalFullscreen] = useState({
        fullScreenEl: false,
    });

    // Referencia mutable para persisitir el respaldo sin causar re-renders innecesarios
    const backupRef = useRef({});

    /**
     * Ajusta el rango de fechas de un objeto de respaldo eliminando eventos
     * cuya 'fecha_hasta' haya quedado fuera del nuevo periodo.
     */
    const adjustBackupDates = (backupItem, fechaInicio, fechaTermino) => {
        if (!backupItem || !fechaInicio || !fechaTermino) return backupItem;

        const clonedItem = JSON.parse(JSON.stringify(backupItem));
        const estados = clonedItem?.Objetivo?.Nodo?.[0]?.estado;
        if (!Array.isArray(estados) || estados.length === 0) return clonedItem;

        const inicio = moment(fechaInicio);

        // 1. Descartamos los eventos cuya fecha_hasta sea anterior o igual a fecha_inicio
        const validEstados = estados.filter((evento) =>
            moment(evento.fecha_hasta).isAfter(inicio)
        );

        if (validEstados.length > 0) {
            // 2. El nuevo primer evento ajusta su fecha_desde
            validEstados[0].fecha_desde = fechaInicio;

            // 3. El último evento ajusta su fecha_hasta con fecha_termino
            const lastIndex = validEstados.length - 1;
            validEstados[lastIndex].fecha_hasta = fechaTermino;

            clonedItem.Objetivo.Nodo[0].estado = validEstados;
        } else {
            // Edge Case: Si TODOS los eventos anteriores quedaron descartados por estar en el pasado,
            // extendemos el último estado conocido a través de todo el nuevo rango de fechas.
            const lastKnownStatus = estados[estados.length - 1]?.nombre || "sin_datos";
            
            clonedItem.Objetivo.Nodo[0].estado = [
                {
                    fecha_desde: fechaInicio,
                    nombre: lastKnownStatus,
                    fecha_hasta: fechaTermino
                }
            ];
        }
        return clonedItem;
    };

    /**
     * Extrae el rango de fechas de referencia buscando en los elementos exitosos
     */
    const getReferenceDatesFromSuccessful = (successfulList) => {
        for (const item of successfulList) {
            const estados = item?.Objetivo?.Nodo?.[0]?.estado;
            if (Array.isArray(estados) && estados.length > 0) {
                return {
                    fechaInicio: estados[0].fecha_desde,
                    fechaTermino: estados[estados.length - 1].fecha_hasta
                };
            }
        }
        return { fechaInicio: null, fechaTermino: null };
    };

    const processData = useCallback(async () => {
        setIsLoading(true);
    
        try {
            const { successful, pending } = await getDetalleDisponibilidadParcialObjetivoDowntime(
                objectives,
                periodState
            );
    
            // 1. Guardar o actualizar la respuesta fresca más reciente en backupRef
            successful.forEach((item) => {
                const id = item?.objetivo_id || item?.Objetivo?.Objetivo_Id;
                if (id) {
                    backupRef.current[id] = item;
                }
            });
    
            // 2. Extraer dinámicamente las fechas de referencia desde las llamadas exitosas
            const { fechaInicio, fechaTermino } = getReferenceDatesFromSuccessful(successful);
    
            // 3. Combinar los datos
            const combinedData = objectives.map((service) => {
                const successItem = successful.find(
                    (s) => (s.objetivo_id || s?.Objetivo?.Objetivo_Id) === service.objetivo_id
                );
    
                // Caso A: Respuesta exitosa de la consulta actual
                if (successItem) {
                    return {
                        ...successItem,
                        isBackup: false
                    };
                }
    
                // Caso B: Petición fallida -> Usar respaldo ajustado con las fechas extraídas
                const cachedItem = backupRef.current[service.objetivo_id];
                if (cachedItem) {
                    // Si no hay fechaInicio/fechaTermino (ej: fallaron todas), se retorna el respaldo sin alterar
                    const updatedBackupItem = (fechaInicio && fechaTermino)
                        ? adjustBackupDates(cachedItem, fechaInicio, fechaTermino)
                        : cachedItem;
    
                    return {
                        ...updatedBackupItem,
                        isBackup: true
                    };
                }
    
                // Caso C: Petición fallida y sin respaldo
                return {
                    ...service,
                    isBackup: false
                };
            });
    
            // 4. Filtrar datos
            const objectivesGraphData = combinedData.filter(
                (item) => item?.Objetivo?.Nodo?.[0]?.estado?.length
            );
    
            setApiData(objectivesGraphData);
    
        } catch (err) {
            console.error("Error al procesar los datos:", err);
        } finally {
            setIsLoading(false);
            setLastUpdate(new Date());
        }
    }, [objectives, periodState]);

    useEffect(() => {
        if (!isLoadingObjectives) {
            processData();
        }
    }, [isLoadingObjectives, processData]);

    const graphData = React.useMemo(() => {
        if (!apiData) return null;
        const graphDataFilteredByTags = filterObjectivesByTags({
            filterTagsId,
            filterTagsType,
            objectives: apiData,
        }).map((objetivo, index) => {
            const series = getSeries(objetivo, index, isSpecial, t);
            objetivo.data = series.consolidatedData;
            objetivo.detailIndividualData = series.detailIndividualData;
            return objetivo;
        });

        const categories = graphDataFilteredByTags.map((item) => item.nombre);
        const series = graphDataFilteredByTags.flatMap(
            (item) => item.detailIndividualData
        );
        return { categories, series };
    }, [apiData, filterTagsId, filterTagsType, isSpecial]);

    function changeGlobalPeriod({ period, statePeriod }) {
        const newSelectedPeriodState = createSelectedPeriodState(
            period,
            0,
            statePeriod
        );
        setPeriodState(newSelectedPeriodState);

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["periodo"] = period;
        if (period === "c") {
            const startDate =
                statePeriod &&
                moment(statePeriod.startDate).format("YYYY-MM-DD");
            const endDate =
                statePeriod && moment(statePeriod.endDate).format("YYYY-MM-DD");
            queryParamsParsed["startDate"] = startDate;
            queryParamsParsed["endDate"] = endDate;
        } else {
            delete queryParamsParsed["startDate"];
            delete queryParamsParsed["endDate"];
        }

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    function updateEtiquetas(etiquetas, type) {
        const ids = etiquetas.map((etiqueta) => etiqueta.etiqueta_id);
        setFilterTagsId(ids);
        setFilterTagsType(type);

        const queryParamsParsed = queryString.parse(document.location.search);
        queryParamsParsed["filterType"] = type;
        queryParamsParsed["etiquetas"] = ids.join("T");

        window.history.replaceState(
            null,
            "Estado General",
            `/generalStatus?${queryString.stringify(queryParamsParsed)}`
        );
    }

    function openModal(category) {
        const objective = objectives.find((o) => o.nombre === category);
        if (objective) {
            setDataModal({
                objId: objective.objetivo_id,
                objNameModal: category,
                open: true,
            });
        }
    }

    function handleCloseModal() {
        setDataModal({
            open: false,
            objId: null,
            objNameModal: null,
        });
    }


    function handleCloseFullScreen() {
        setDataModalFullscreen({
            fullScreenEl: false
        });
    };

    const lastUpdateFormat = moment(lastUpdate)
        .tz(sessionStorage.getItem("tz"))
        .format("DD/MM/YYYY, h:mm:ss a");

    function handleChangeAutoRefresh(event) {
        const newValue = !Boolean(event.target.value === "true");
        setAutoRefresh(newValue ? INTERVAL : null);
    }
    const handleChangeSwitch = (event) => {
        setIsSpecial(event.target.checked);
    };
    return (
        <Box>
            <Box padding={2}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box marginBottom={2}>
                            <Box display="flex" alignContent="center">
                                <UpdateIcon />
                                <Typography
                                    style={{
                                        fontWeight: "bold",
                                        marginLeft: 10,
                                    }}
                                >
                                    {t('text.last-update')}: {lastUpdateFormat}
                                </Typography>
                            </Box>
                            {autoRefresh && (
                                <Box>
                                    <small style={{ fontSize: 12 }}>
                                        {t('general-status.text.auto-update')}
                                    </small>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <FilterTags
                            listObjectives={[]}
                            updateEtiquetas={(etiquetas, filterType = "OR") =>
                                updateEtiquetas(etiquetas, filterType)
                            }
                            tagsId={filterTagsId}
                            preload={true}
                            filterTagsType={filterTagsType}
                            showFilterType={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box display="flex" justifyContent="end">
                            <Box display="flex">
                                <AtSelectPeriod
                                    persistInStorage={false}
                                    hideApplyToAll={true}
                                    changePeriodFn={changeGlobalPeriod}
                                    defaultPeriods={defaultPeriodsGeneralStatus}
                                    activePeriodFromParent={activePeriodState}
                                    customMaxDate={new Date()}
                                    limitDays={31}
                                />
                                <Tooltip title={t('text.fullscreen')}>
                                    <IconButton
                                    onClick={(e) =>
                                        setDataModalFullscreen({ fullScreenEl: true})
                                    }
                                    styles={{ float: "right" }}
                                    >
                                        <FullscreenIcon />
                                    </IconButton>
                                </Tooltip>
                                <IconButton
                                    onClick={(e) =>
                                        setConfigEl(e.currentTarget)
                                    }
                                    styles={{ float: "right" }}
                                >
                                    <SettingsOutlinedIcon />
                                </IconButton>
                            </Box>
                            <ConfigPopover
                                el={configEl}
                                handleRefresh={() => processData()}
                                handleClose={() => setConfigEl(null)}
                                autoRefresh={Boolean(autoRefresh)}
                                handleChangeAutoRefresh={
                                    handleChangeAutoRefresh
                                }
                            />
                        </Box>
                        <Box display='flex' alignItems='center' justifyContent='end'>
                            <Typography variant='h6' style={{color: "#6b6b6b"}}>
                            {isGlobal ? t('general-status.text.global-general-status') : t('general-status.text.special-general-status')}
                            </Typography>
                            <Box style={{marginLeft: '10px', marginRight: '10px'}}>
                                <Switch
                                    checked={isSpecial}
                                    onChange={handleChangeSwitch}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    color='primary'
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                {isLoading ? (
                    <Box marginBottom={2}>
                        <LinearProgress />
                    </Box>
                ) : null}
                {!isLoading && graphData?.categories.length === 0 ? (
                    <Alert style={{ marginBottom: 10 }} severity="warning">
                        {t('general-status.alert.message.no-objectives')}
                    </Alert>
                ) : null}
                {graphData && (
                    <Alert severity="info" style={{ width: "100%" }}>
                        {t('general-status.alert.message')}
                    </Alert>
                )}
                {graphData?.categories.length > 0 && !isLoading ? (
                    <Box style={{ display: "flex", justifyContent: "center" }}>
                        <Box
                            marginTop={2}
                            sx={{ minWidth: "80vw", maxWidth: "80vw" }}
                        >
                            <ObjectiveZoomGraph
                                categories={graphData.categories}
                                series={graphData.series}
                                openModal={openModal}
                            />
                        </Box>
                    </Box>
                ) : null}
            </Box>
            <Dialog
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={dataModal.open}
                onClose={handleCloseModal}
                maxWidth={"lg"}
                fullWidth={true}
            >
                {objectivesListData && (
                    <ListObjectiveModal
                        obj={dataModal.objId}
                        objName={dataModal.objNameModal}
                        listObjectives={objectivesListData}
                        handleClose={handleCloseModal}
                    />
                )}
            </Dialog>
            <Dialog
                fullScreen
                open={dataModalFullscreen.fullScreenEl}
                onClose={handleCloseFullScreen}
                container={() => document.body}
                PaperProps={{
                    style: {
                        margin: 0,
                        padding: 0,
                        width: '100vw',
                        height: '100vh',
                        maxWidth: '100vw',
                        maxHeight: '100vh',
                        borderRadius: 0
                    }
                }}
            >
                {/* Header compacto de cierre */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '4px 12px',
                    backgroundColor: '#0b1738',
                    color: '#fff',
                    height: '40px'
                }}>
                    {/* Grupo Izquierdo */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img
                            alt="Atentus logo"
                            style={{ height: 45 }}
                            src={"/images/logos/atentus-isotipo.svg"}
                        />
                        <Typography variant="h3" style={{ color: '#fff' }}>
                            {t('dashboard-layout.title.general-status')}
                        </Typography>
                    </div>

                    {/* Grupo Derecho */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Typography variant="h6">
                            {/* @TODO: Agregar Nombre de Usuario - Correo desde API */}
                            {email}
                        </Typography>
                        <IconButton onClick={handleCloseFullScreen} style={{ color: '#fff', padding: 4 }}>
                            <ClearIcon />
                        </IconButton>
                    </div>
                </div>

                {/* Contenedor sin padding para pegar la tabla a los bordes */}
                <div style={{ 
                    padding: 0, // <--- Elimina el espacio blanco alrededor
                    margin: 0,
                    height: 'calc(100vh - 40px)', 
                    width: '100%',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {isLoading ? (
                        <Box marginBottom={2}>
                            <LinearProgress />
                        </Box>
                    ) : null}
                    {!isLoading && graphData?.categories.length === 0 ? (
                        <Alert style={{ marginBottom: 10 }} severity="warning">
                            {t('general-status.alert.message.no-objectives')}
                        </Alert>
                    ) : null}
                    {graphData?.categories.length > 0 && !isLoading ? (
                        <Box style={{ display: "flex", justifyContent: "center" }}>
                            <Box
                                marginTop={2}
                                sx={{ minWidth: "80vw", maxWidth: "80vw" }}
                            >
                                <ObjectiveZoomGraph
                                    categories={graphData.categories}
                                    series={graphData.series}
                                    openModal={openModal}
                                />
                            </Box>
                        </Box>
                    ) : null}
                </div>
            </Dialog>
        </Box>
    );
}

export default withRouter(PanelAvailabilityCopy);